import { createEffect, ofType } from '@ngrx/effects';
import { Actions } from '@ngrx/effects';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { catchError, delay, exhaustMap, map, mergeMap, of, switchMap, tap } from 'rxjs';
import {checkAuthStatus, checkAuthStatusFailure, checkAuthStatusSuccess, login, loginFailure, loginSuccess, logout } from '../actions/auth.action';
import { HttpErrorResponse, HttpResponse } from '@angular/common/http';
import { Store } from '@ngrx/store';
import { showalert } from '../actions/warning.action';
import { AuthService } from '../../services/auth.service';

@Injectable()
export class AuthEffects {
  constructor(
    private actions$: Actions,
    private authService: AuthService,
    private router: Router,
    private store: Store
  ) {}
  
  AuthLogin$ = createEffect(() =>
    this.actions$.pipe(
      ofType(login),
      exhaustMap((action) =>
        this.authService.loginAsync(action.userCred).pipe(
          map((authStatus) => {
            if (authStatus.isSuccess) {
              this.router.navigate(['dashboard']);
              this.store.dispatch(showalert({ severity: 'success', summary: 'Succès', detail: 'Connexion réussie'}));
              return loginSuccess();
            } else {
              return showalert({ severity: 'error', summary: 'Error', detail: 'Login failed'});
            }
          }),
          catchError((error) =>
            of(showalert({severity: 'error', summary: 'Error', detail: `Login failed due to: ${error.message}` }))
          ),
        )
      )
    )
  );

  checkAuthStatus$ = createEffect(() =>
    this.actions$.pipe(
      ofType(checkAuthStatus),
      mergeMap(() =>
        this.authService.checkAuthStatus().pipe(
          map((response : HttpResponse<any>) =>{
            const isAuthenticated = response.status === 200;
            return checkAuthStatusSuccess({isAuthenticated : isAuthenticated})
          }
          ),
          catchError((error) =>
            of(checkAuthStatusFailure({ error }))
          )
        )
      )
    )
  );

  authError$ = createEffect(() =>
    this.actions$.pipe(
      ofType(loginFailure),
      tap(() => {
        //this.router.navigate(['/auth/login']); // Redirect to login page
      })
    ),
    { dispatch: false }
  );



  
}
